// bedView picks which captured camera view feeds the fusion: 'default' (head to the right, fits
// rooms whose head-wall is on the right) or 'room' (elevated head-at-back, fits rooms whose
// head-wall faces the viewer). See Visualization.js updateScreenshotCameraViews.
export const MILIEUS = [
  { slug: 'coastal', name: 'Coastal', full: 'coastal.jpg', thumb: 'coastal_thumb.jpg', bedView: 'room' },
  {
    slug: 'great-plains',
    name: 'Great Plains',
    full: 'great-plains.jpg',
    thumb: 'great-plains_thumb.jpg',
    bedView: 'default',
  },
  {
    slug: 'metro-new-york',
    name: 'Metro New York',
    full: 'metro-new-york.jpg',
    thumb: 'metro-new-york_thumb.jpg',
    bedView: 'default',
  },
  { slug: 'mountain', name: 'Mountain', full: 'mountain.jpg', thumb: 'mountain_thumb.jpg', bedView: 'room' },
  { slug: 'pacific', name: 'Pacific', full: 'pacific.jpg', thumb: 'pacific_thumb.jpg', bedView: 'room' },
  { slug: 'veteran', name: 'Veteran', full: 'veteran.jpg', thumb: 'veteran_thumb.jpg', bedView: 'default' },
];

export function milieuImageUrl(baseImageUrl, file) {
  return `${String(baseImageUrl || '').replace(/\/$/, '')}/milieu-images/${file}`;
}
